import './mainPage.css';
import {
  BenefitArea,
  ClientArea,
  FaqArea,
  HeroArea,
  ProgramArea,
  Testimonials,
  WorkArea,
} from './';
import { useEffect, useState } from 'react';

function MainPage() {
  const [showLanding, setShowLanding] = useState(false)

  useEffect(() =>{
    setShowLanding(true);
  }, [])
  return (
    <>
    {
      showLanding &&
        <>
          <HeroArea />
         {
          /*
           <Testimonials />
            <WorkArea />
            <BenefitArea />
            <ProgramArea />
            <FaqArea />
            */
         }
        </>
    }
    </>
  );
}

export default MainPage;
